import { useMemo, useState } from "react";
import { withInfiniteQueryData } from "../../../../../common/withQueryData";
import { dateUtils } from "../../../../../utils/DateUtils";
import TableCalendar from "./TableCalendar";
import { Box } from "@mui/material";
import { useDailyAvailabilityAndPrices } from "../../../../../common/hooks/useAvailabilityAndPricingData";

const getEndDate = (startDate) => {
    const endDate = dateUtils.atMidnight(new Date(startDate.toDateString()));
    endDate.setDate(startDate.getDate() + 45);

    return endDate;
}

const TableCalendars = ({ rooms, plans, propertyId }) => {
    return <>
        {rooms.map((room, index) => <TableCalendarWrapper
            room={room}
            plans={plans}
            propertyId={propertyId}
            key={room.id}
            index={index}
        />)}
    </>
}

const TableCalendarWrapper = ({ ...props }) => {
    const { room, propertyId } = props;

    const [fromDate, setFromDate] = useState(dateUtils.atMidnight(new Date()));//setting today by default
    const toDate = useMemo(() => getEndDate(fromDate), [fromDate]);

    const { queryResults } = useDailyAvailabilityAndPrices(propertyId, room.id, fromDate, toDate);

    const onStartDateChange = (date) => {
        setFromDate(date);
    }

    return <Box sx={{ minHeight: '300px', position: 'relative' }}>
        <TableCalendarWithInfiniteQueryData
            queryResults={queryResults}
            onStartDateChange={onStartDateChange}
            {...props}
        />
    </Box>
}

const TableCalendarWithInfiniteQueryData = withInfiniteQueryData(TableCalendar);

export default TableCalendars;